import React from 'react';
import { Text, View, StyleSheet, Pressable, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../../constants/styles';
import { OPComponent } from '../../components';

import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';

import moment from 'moment';
const localizer = momentLocalizer(moment);
const EMPTY_ARRAY = [];

import {
  nowDate,
  dateIsPast,
  expandRange,
  customMonthComp,
  customEventWrapperComp,
  TouchCellWrapper,
  isInRange,
} from './helpers';

export default class ScheduleCal extends OPComponent {
  constructor(props) {
    super(props);

    let selectedDate;
    if (props.selectedDate) {
      selectedDate = props.selectedDate;
    } else {
      selectedDate = nowDate();
      if (props.firstAvailableDateFrom) {
        selectedDate = props.firstAvailableDateFrom(selectedDate);
      }
    }

    this.state = {
      selectedDate,
      selectedRange: null,
    };

    this._CustomEventWrapper = customEventWrapperComp(
      props.dotStyle,
      props.onHoverIn,
      props.onHoverOut
    );
  }

  componentDidMount() {
    this.props.onSelectedDate?.(this.state.selectedDate);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedDate !== prevProps.selectedDate) {
      this.setSelectedDate(this.props.selectedDate, true);
    }
  }

  componentWillUnmount() {}

  calDisplayTextAsInSelectedRangeForDate = (date) => {
    if (!this.state.selectedRange) return false;
    return isInRange(date, expandRange(this.state.selectedRange, (includePastDays = true)));
  };
  getSelectedDate = () => {
    return this.state.selectedDate;
  };
  setSelectedDate(selectedDate, skipEvent = false) {
    this.setState({ selectedDate });

    if (!skipEvent) this.props.onSelectedDate?.(selectedDate);
  }
  setSelectedRange(range) {
    this.setState({ selectedRange: range });

    this.props.onSelectedRange?.(
      (range && expandRange(range, !this.props.disablePastSelect)) || null,
      range
    );
  }
  updateSelectedDate = (month) => {
    const props = this.props;
    const { selectedDate } = this.state;
    let newSelectedDate = new Date(selectedDate);
    newSelectedDate.setDate(1);
    newSelectedDate.setMonth(newSelectedDate.getMonth() + month);
    const now = nowDate();
    if (props.disablePastSelect && newSelectedDate < now) newSelectedDate = now;
    if (props.firstAvailableDateFrom) {
      newSelectedDate = props.firstAvailableDateFrom(newSelectedDate);
    }
    this.setSelectedDate(newSelectedDate);
  };
  incrementSelectedDate = () => {
    this.updateSelectedDate(1);
  };
  decrementSelectedDate = () => {
    this.updateSelectedDate(-1);
  };

  handleDrillDown = (start) => {
    this.selectSlot({ start });
  };

  selectSlot = ({ start, end }) => {
    if (this.props.canSelectSlot?.(start, end) === false) return false;
    if (this.props.disablePastSelect !== false && dateIsPast(start)) return false;

    if (!!this.props.multi) {
      if (end && moment(start).add(1, 'days').isBefore(moment(end))) {
        this.setSelectedRange({ start, end });
      } else {
        this.setSelectedRange(null);
      }
    }
    this.setSelectedDate(start);
  };

  handleLayout = (e) => {
    if (!e.nativeEvent) return;
    const w = e.nativeEvent.layout.width;
    this._updateLayout(w);
  };
  _updateLayout = (width) => {
    const calHeight = parseInt((width * 5) / 7 + 50);
    this.setState({ calHeight });
    this.props.onHeight?.(calHeight);
  };

  render() {
    const props = this.props;

    const showLeftArrow = props.arrowEnabled
      ? props.arrowEnabled(this.state.selectedDate, -1)
      : !props.disablePastSelect || this.state.selectedDate.getMonth() !== new Date().getMonth();
    const showRightArrow = props.arrowEnabled
      ? props.arrowEnabled(this.state.selectedDate, 1)
      : true;

    const CustomMonthView = customMonthComp(
      this.props.calDisplayTextAsOffRangeForDate,
      this.calDisplayTextAsInSelectedRangeForDate
    );

    return (
      <View style={styles.container}>
        <View style={styles.calControlsContainer}>
          {!!showLeftArrow ? (
            <Pressable style={styles.leftRightArrowContainer} onPress={this.decrementSelectedDate}>
              <Image
                style={styles.leftRightArrow}
                source={require('../../../../resources/arrow-left.png')}
              />
            </Pressable>
          ) : (
            <View style={{ width: 58 }} />
          )}
          <Text style={styles.monthLabel}>
            {moment(this.state.selectedDate).format('MMMM, YYYY')}
          </Text>
          {!!showRightArrow ? (
            <Pressable style={styles.leftRightArrowContainer} onPress={this.incrementSelectedDate}>
              <Image
                style={styles.leftRightArrow}
                source={require('../../../../resources/arrow-right-hover.png')}
                testID="rightArrow"
              />
            </Pressable>
          ) : (
            <View style={{ width: 58 }} />
          )}
        </View>

        <View
          style={[{ height: this.state.calHeight }]}
          onLayout={!this.state.calHeight ? this.handleLayout : null}
        >
          <BigCalendar
            className={props.className}
            localizer={localizer}
            events={props.events || EMPTY_ARRAY}
            titleAccessor="eventName"
            tooltipAccessor="eventName"
            resourceTitleAccessor="eventId"
            startAccessor="startDate"
            endAccessor="endDate"
            toolbar={true}
            onDrillDown={this.handleDrillDown}
            getNow={this.getSelectedDate}
            defaultView={'month'}
            view={'month'}
            views={{ month: CustomMonthView }}
            onView={() => {}}
            step={720}
            selectable
            onSelectSlot={props.selectSlot || this.selectSlot}
            onSelectEvent={this.selectEvent}
            components={{
              eventWrapper: this._CustomEventWrapper,
              dateCellWrapper:
                props.dateCellWrapperFunc ||
                ((props) => (
                  <TouchCellWrapper
                    {...props}
                    onSelectSlot={this.selectSlot}
                    calCellBGClassForDate={this.props.calCellBGClassForDate}
                  />
                )),
            }}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  calControlsContainer: {
    ...THEME.basicRow,
    paddingVertical: 5,
  },
  leftRightArrowContainer: {
    marginHorizontal: 15,
    marginVertical: 10,
  },
  leftRightArrow: {
    marginVertical: 'auto',
    width: 18,
    height: 12,
    tintColor: COLOR.textLight,
  },
  monthLabel: {
    flex: 1,
    ...THEME.textRegular,
    color: COLOR.textLight,
    textAlign: 'center',
    fontSize: FONT_SIZE.large,
  },
});
